import { useState, type ReactNode, type SyntheticEvent } from 'react';

import { Carte } from './communs.tsx';

/**
 * Saisie du motif avant une désactivation — RG-005.
 *
 * Le serveur exige un motif d'au moins 10 caractères sur les désactivations
 * de clients et de fournisseurs. L'interface envoyait jusqu'ici une phrase
 * ÉCRITE EN DUR — « Desactivation depuis l administration » — sur chaque
 * opération.
 *
 * Le validateur était satisfait, et la règle vidée de son sens : le journal
 * d'audit est append-only et chaîné justement pour qu'on puisse retrouver le
 * « pourquoi » des mois plus tard, en cas de litige. Une constante n'apprend
 * rien à personne.
 *
 * Le motif est donc demandé à celui qui agit, au moment où il agit — seul
 * moment où il le connaît.
 */
export function DemandeMotif({
  titre,
  description,
  libelleAction,
  enCours = false,
  onValider,
  onAnnuler,
}: {
  titre: string;
  /** Ce que l'action va réellement faire, en clair. */
  description: string;
  libelleAction: string;
  enCours?: boolean;
  onValider: (motif: string) => void;
  onAnnuler: () => void;
}): ReactNode {
  const [motif, setMotif] = useState('');

  const restant = 10 - motif.trim().length;
  const valide = restant <= 0;

  function soumettre(evenement: SyntheticEvent): void {
    evenement.preventDefault();
    if (valide) {
      onValider(motif.trim());
    }
  }

  return (
    <Carte>
      <form onSubmit={soumettre}>
        <h2>{titre}</h2>
        <p className="entete__sous" style={{ marginBottom: 14 }}>
          {description}
        </p>

        <div className="champ">
          <label htmlFor="motif-action">Motif</label>
          <input
            id="motif-action"
            autoFocus
            maxLength={500}
            value={motif}
            placeholder="Ce qui justifie cette décision"
            onChange={(evenement) => {
              setMotif(evenement.target.value);
            }}
            aria-describedby="motif-aide"
          />
          {/*
            Le compte à rebours DIT ce qui manque au lieu d'attendre un refus.
            Sans lui, le serveur répond « motif : String must contain at least
            10 character(s) », et l'utilisateur doit deviner la règle.
          */}
          <div id="motif-aide" className="entete__sous">
            {valide
              ? 'Ce motif sera conservé dans le journal d’audit.'
              : `Encore ${String(restant)} caractère${restant > 1 ? 's' : ''}.`}
          </div>
        </div>

        <div className="ligne">
          <button type="submit" disabled={!valide || enCours}>
            {enCours ? 'Enregistrement…' : libelleAction}
          </button>
          <button type="button" className="bouton--discret" onClick={onAnnuler}>
            Annuler
          </button>
        </div>
      </form>
    </Carte>
  );
}
